import React from "react";
import { GraduationCap, HeartPulse, BookOpen } from "lucide-react";
import { DOCTOR_IMG, CLINIC_IMG, whatsappLink } from "../../lib/site";

const highlights = [
  { icon: HeartPulse, title: "Atendimento individualizado", desc: "Escuta atenta e plano construído a partir da sua história clínica." },
  { icon: BookOpen, title: "Atualização científica constante", desc: "Protocolos baseados em evidências e nas técnicas mais atuais." },
  { icon: GraduationCap, title: "Foco em resultados e bem-estar", desc: "Compromisso com qualidade de vida — não apenas com o alívio momentâneo." },
];

export const About = () => {
  return (
    <section id="sobre" data-testid="about-section" className="py-20 sm:py-24 lg:py-32 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        {/* LEFT — photo + clinic */}
        <div className="lg:col-span-5">
          <div className="relative">
            {/* <img
                src={CLINIC_IMG}
              alt="Ambiente clínico de alto padrão"
              className="hidden sm:block absolute -top-6 -right-6 w-48 h-48 lg:w-56 lg:h-56 object-cover rounded-lg shadow-xl border-4 border-white"
            /> */}
            <img
              data-testid="about-doctor-image"
              src= "drafotosobre.jpeg"
              alt="Dra. Luz Adriana"
              className="relative w-full max-w-md rounded-lg shadow-2xl object-cover aspect-[4/5]"
            />
            <div className="absolute -bottom-5 left-6 bg-[#0A2540] text-white px-6 py-4 rounded-lg shadow-xl">
              <p className="overline text-[#D4AF37]">Dra.</p>
              <p className="font-serif-display text-xl leading-tight">Luz Adriana Paez</p>
            </div>
          </div>
        </div>

        {/* RIGHT — Bio */}
        <div className="lg:col-span-7">
          <p className="overline text-[#D4AF37] mb-5">Sobre mim</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0A2540] leading-tight tracking-tight">
            Dra. Luz Adriana Paez
          </h2>

          <div className="mt-8 space-y-5 text-[#1A1A1A]/75 leading-relaxed">
            <p><span className="text-[#0A2540]/70">CRM: 5258552-0  |  RJ</span>
            </p>
            <p>
              Sou a <span className="text-[#0A2540] font-semibold">Dra. Luz Adriana Paez</span>{" "}
              ,
              médica especialista em Medicina Física e Reabilitação (Fisiatria), com formação pela ABBR. Desde <span className="text-[#0A2540] font-semibold">1993</span>,
              venho construindo minha trajetória profissional com foco no
              tratamento clínico da dor e no manejo de distúrbios do movimento.
              
            </p>
            <p>

              Minha experiência abrange reabilitação neurológica, reabilitação musculoesquelética, neurofisiologia clínica e fisiatria,
              com foco em devolver funcionalidade, autonomia e qualidade de vida aos pacientes.
            </p>
            <p>

              Realizo atendimento a adultos e crianças, conforme a disponibilidade de cada unidade de atendimento,
              sempre com tratamentos personalizados e centrados nas necessidades de cada paciente.
            </p>
            <p>
              Mais do que tratar sintomas, minha missão é{" "}
              <span className="text-[#0A2540] font-semibold">devolver
              qualidade de vida</span> a quem já tentou diversos caminhos e
              ainda não encontrou alívio.
            </p>
          </div>

          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
            {highlights.map((h, i) => {
              const Icon = h.icon;
              return (
                <li
                  key={h.title}
                  data-testid={`about-highlight-${i}`}
                  className="bg-[#F8F9FA] border border-[#E9ECEF] rounded-lg p-5"
                >
                  <Icon className="w-6 h-6 text-[#D4AF37] mb-3" strokeWidth={1.6} />
                  <p className="font-semibold text-[#0A2540] text-sm">{h.title}</p>
                  <p className="text-xs text-[#1A1A1A]/65 mt-1.5 leading-relaxed">{h.desc}</p>
                </li>
              );
            })}
          </ul>

          <a
            data-testid="about-cta"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center justify-center bg-[#D4AF37] hover:bg-[#E5C158] text-[#0A2540] font-semibold px-7 py-4 rounded-sm transition-colors shadow-md"
          >
            Agendar consulta com a Dra. Luz Adriana
          </a>
        </div>
      </div>
    </section>
  );
};
